
import Groups2Icon from '@mui/icons-material/Groups2';
import BurstModeIcon from '@mui/icons-material/BurstMode';
import CampaignIcon from '@mui/icons-material/Campaign';


const DigitalMarketing = {
  id: '25',
  title: 'Digital Marketing',
  type: 'group',
  role: 'FACTORY_MANAGER',
  children: [
    {
      id: 'audience',
      title: 'Audience',
      type: 'item',
      url: '/audiencepage',
      icon: Groups2Icon
    },{
      id: 'template',
      title: 'Template',
      type: 'item',
      url: '/templatepage',
      icon: BurstModeIcon
    },{
      id: 'campaign',
      title: 'Campaign',
      type: 'item',
      url: '/campaignpage',
      icon: CampaignIcon
    },
  ]
};

export default DigitalMarketing;